import TextInput from './text';

export default TextInput;
